import { render, staticRenderFns } from "./club.vue?vue&type=template&id=6b61508a&scoped=true&"
import script from "./club.vue?vue&type=script&lang=js&"
export * from "./club.vue?vue&type=script&lang=js&"
import style0 from "./club.vue?vue&type=style&index=0&id=6b61508a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61508a",
  null
  
)

export default component.exports